<section>
  <app-time-slot-calendar></app-time-slot-calendar>
</section>
<section>
  <app-time-slot-list (timeSlotSelected)="onTimeSlotSelected($event)"></app-time-slot-list>
</section>
